import { TextField } from '@openx/components-core/lib/TextField/TextField';
import type { AppInventoryOptionType } from '@openx/types/targeting/appInventory';
import { InventoryContentOption } from '@openx/types/targeting/inventoryAndContent';
import { type KeyboardEvent, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { INVENTORY_LIMITS } from '../../shared/InventoryAndContent/constants';

type InventoryInputProps = {
  onKeyUp: (e: KeyboardEvent<HTMLInputElement>) => void;
  option: InventoryContentOption | AppInventoryOptionType;
  errorText: string;
  itemsCount: number;
};

export const InventoryInput = (props: InventoryInputProps) => {
  const { onKeyUp, option, errorText, itemsCount } = props;
  const { t } = useTranslation();

  const isLimitReached = itemsCount >= INVENTORY_LIMITS[option];

  const placeholder = useMemo(() => {
    const placeholders = {
      [InventoryContentOption.ADUNIT]: t('Enter an Ad Unit ID and press Enter'),
      [InventoryContentOption.APP_BUNDLE_ID]: t('Enter an app bundle ID and press Enter'),
      [InventoryContentOption.PAGE_URL]: t('Enter a page URL and press Enter'),
      [InventoryContentOption.SITE]: t('Enter an Site ID and press Enter'),
    };
    return isLimitReached
      ? t('The limit has been reached ({limit}).', { limit: INVENTORY_LIMITS[option] })
      : placeholders[option];
  }, [isLimitReached, option, t]);

  const labels = {
    [InventoryContentOption.APP_BUNDLE_ID]: t('App Bundle ID'),
    [InventoryContentOption.PAGE_URL]: t('Page URL'),
  };

  return (
    <TextField
      name="inventory_and_content"
      placeholder={placeholder}
      fullWidth
      margin="dense"
      data-test="inventory-and-content-input"
      autoComplete="off"
      onKeyUp={onKeyUp}
      style={{
        margin: 0,
        marginBottom: errorText ? '-20px' : '0px',
      }}
      error={!!errorText}
      helperText={errorText}
      disabled={isLimitReached}
      label={labels[option]}
    />
  );
};
